// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"778":"750225fd","841":"4314bc9b","996":"750225fd"}[chunkId] + ".chunk.css";
};